import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"

import "./WaveSaleslandingpage/css/style.css"
import logo from "./WaveSaleslandingpage/img/logo.png"
import FloatingWhatsApp from "../components/FloatingWhatsApp"

function AboutWaveSales() {
  const [theme, setTheme] = useState("light")

  useEffect(() => {
    document.body.classList.remove("light", "dark")
    document.body.classList.add(theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"))
  }

  return (
    <div className="about-page">

      {/* ================= HEADER ================= */}
      <header>
        <div className="container header-container">
          {/* LOGO */}
          <div className="logo">
            <img src={logo} alt="WaveSales" />
          </div>

          {/* MENU */}
          <nav>
            <ul className="menu">
              <li><Link to="/#inicio">Inicio</Link></li>
              <li><Link to="/#pricing">Precios</Link></li>
              <li><Link to="/nosotros" className="active">Nosotros</Link></li>
              <li><Link to="/#products">Productos</Link></li>
              <li><Link to="/#resources">Recursos</Link></li>
              <li><Link to="/#blog">Blog</Link></li>
            </ul>
          </nav>

          {/* ACTIONS */}
          <div className="header-actions">
            <button
              type="button"
              onClick={toggleTheme}
              className="btn-secondary"
              aria-label="Cambiar tema"
            >
              {theme === "dark" ? "☀️" : "🌙"}
            </button>

            <select className="lang-select" defaultValue="ES">
              <option value="ES">ES</option>
              <option value="EN">EN</option>
            </select>

            <Link to="/login" className="btn-login">Ingresar</Link>
          </div>
        </div>
      </header>

      {/* ================= HERO ================= */}
      <section className="about-hero">
        <div className="container about-hero-content">
          <span className="badge">Sobre nosotros</span>
          <h1>
            Profesionalizamos la comunicación<br />
            empresarial por WhatsApp
          </h1>
          <p>
            WaveSales ayuda a empresas a conectarse con sus clientes
            mediante WhatsApp Business API de forma oficial, segura y escalable.
          </p>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="about-main">
        <div className="container about-grid">

          <div className="about-text">
            <h2>¿Qué es WaveSales?</h2>

            <p>
              <strong>WaveSales</strong> es una plataforma tecnológica diseñada
              para empresas que necesitan enviar mensajes, notificaciones y
              campañas utilizando <strong>WhatsApp Business API</strong>
              con <strong>coexistencia oficial de Meta</strong>.
            </p>

            <p>
              Permitimos que un mismo número funcione simultáneamente en
              WhatsApp App y en la API, sin bloqueos ni riesgos,
              cumpliendo todas las políticas oficiales.
            </p>

            <p>
              Desde un solo panel puedes crear plantillas aprobadas,
              importar contactos, segmentar audiencias y enviar campañas
              de manera profesional.
            </p>
          </div>

          <div className="about-features">
            <div className="feature-card">
              🚀 <strong>Coexistencia oficial</strong>
              <span>WhatsApp App + API</span>
            </div>

            <div className="feature-card">
              🧩 <strong>Plantillas aprobadas</strong>
              <span>Cumple políticas de Meta</span>
            </div>

            <div className="feature-card">
              📣 <strong>Campañas masivas</strong>
              <span>Mensajes escalables</span>
            </div>

            <div className="feature-card">
              👥 <strong>Gestión de contactos</strong>
              <span>Listas y segmentación</span>
            </div>

            <div className="feature-card">
              🔐 <strong>Plataforma segura</strong>
              <span>Infraestructura confiable</span>
            </div>

            <div className="feature-card">
              📊 <strong>Enfoque empresarial</strong>
              <span>Para ventas y soporte</span>
            </div>
          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="about-cta">
        <div className="container cta-box">
          <h2>Empieza a usar WhatsApp de forma profesional</h2>
          <p>
            Solicita una demo gratuita y descubre cómo WaveSales
            puede escalar tu comunicación.
          </p>

          <Link to="/demo" className="btn-primary btn-large">
            Solicitar demo gratuita
          </Link>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="bg-gray-900 dark:bg-gray-950 text-gray-300 py-10 border-t border-gray-700 mt-16">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">

          <div>
            <h2 className="text-2xl font-bold text-white mb-3">WaveSales</h2>
            <p className="text-gray-400 text-sm">
              Soluciones oficiales de WhatsApp Business para empresas.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-3">Contáctanos</h3>
            <ul className="text-gray-400 text-sm space-y-2">
              <li>📞 +593 959 163 654</li>
              <li>📧 contacto@wave-sales.com</li>
              <li>📍 Ecuador</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-white mb-3">Enlaces</h3>
            <ul className="text-gray-400 text-sm space-y-2">
              <li><Link to="/#inicio">Inicio</Link></li>
              <li><Link to="/#pricing">Precios</Link></li>
              <li><Link to="/nosotros">Nosotros</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-4 text-center text-gray-500 text-sm">
          © 2025 WaveSales. Todos los derechos reservados.
        </div>
      </footer>

      <FloatingWhatsApp />
    </div>
  )
}

export default AboutWaveSales
